<template>
  <button
    class="btn btn-primary w-full"
    onclick="create_scan_action_dialog.showModal()"
  >
    <i class="fa-solid fa-circle-plus opacity-90"></i>
    <span> Tạo yêu cầu quét </span>
  </button>
  <dialog
    id="create_scan_action_dialog"
    ref="create_scan_action_dialog"
    class="modal"
  >
    <div class="modal-box">
      <h3 class="text-lg font-bold">
        Nhập đường dẫn để quét các tệp tin và thư mục
      </h3>
      <div class="py-4">
        <input ref="path_input_ref" class="input w-full" />
      </div>
      <div class="modal-action">
        <form method="dialog" class="space-x-2">
          <button class="btn">Hủy</button>
        </form>
        <button class="btn btn-primary" @click="submit_create">Xác nhận</button>
      </div>
    </div>
  </dialog>
</template>

<script setup lang="ts">
import { useQueryClient } from "@tanstack/vue-query";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import { use_explorer } from "./useExplorer";

const path_input_ref = ref<HTMLInputElement>();
const create_scan_action_dialog = ref<HTMLDialogElement>();
const queryClient = useQueryClient();

const explorer_store = use_explorer();
const submit_create = () => {
  const path = path_input_ref.value?.value;
  if (!path || path === "") {
    toast.warn("Vui lòng nhập đường dẫn!");
    path_input_ref.value?.focus();
    return;
  }
  explorer_store
    .create_scan_action(path)
    .then(() => {
      if (create_scan_action_dialog.value)
        create_scan_action_dialog.value.close();
    })
    .catch(() => {})
    .finally(() => {
      queryClient.refetchQueries({
        queryKey: ["action_history"],
      });
    });
};
</script>
